/** 请求成功状态码 */
export const SUCCESS_CODE = 0

/** 请求 Content-Type */
export const CONTENT_TYPE: AxiosContentType = 'application/json'

/** 请求超时时间 */
export const REQUEST_TIMEOUT = 60000

/** 不重定向白名单 */
export const NO_REDIRECT_WHITE_LIST = ['/', '/login', '/register', '/forgot-password']

/** Token 存储键名 */
export const TOKEN_KEY = 'Authorization'

/** 用户信息存储键名 */
export const USER_INFO_KEY = 'userInfo'

/** 记住我存储键名 */
export const REMEMBER_ME_KEY = 'rememberMe'

/** 登录信息存储键名 */
export const LOGIN_INFO_KEY = 'loginInfo'

/** 是否根据 headers->content-type 自动转换数据格式 */
export const TRANSFORM_REQUEST_DATA = true
